// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecondStepper_container__OblVU {
  justify-content: center;
}

.SecondStepper_container__OblVU .SecondStepper_tableContainer__o8m07 {
  animation: SecondStepper_init__KM8Jh 0.5s;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.SecondStepper_container__OblVU .SecondStepper_init__KM8Jh {
  animation: SecondStepper_init__KM8Jh 0.5s both;
}

.SecondStepper_container__OblVU .SecondStepper_init2__OA4vM {
  animation: SecondStepper_init__KM8Jh 0.5s 0.2s both;
}

.SecondStepper_input__RDczW {
  color: #a64452;
}

@keyframes SecondStepper_init__KM8Jh {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Create/Steppers Refactor/SecondStepper/SecondStepper.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,yCAAoB;EACpB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,8CAAyB;AAC3B;;AAEA;EACE,mDAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  justify-content: center;\n}\n\n.container .tableContainer {\n  animation: init 0.5s;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .init {\n  animation: init 0.5s both;\n}\n\n.container .init2 {\n  animation: init 0.5s 0.2s both;\n}\n\n.input {\n  color: #a64452;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SecondStepper_container__OblVU`,
	"tableContainer": `SecondStepper_tableContainer__o8m07`,
	"init": `SecondStepper_init__KM8Jh`,
	"init2": `SecondStepper_init2__OA4vM`,
	"input": `SecondStepper_input__RDczW`
};
export default ___CSS_LOADER_EXPORT___;
